export const CLIP = 214;
